const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 443,
    height: 480,
    viewBox: "0 0 443 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "REP") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M310.7,327.5c48.6-19.3,64.1-19.7,82.1-14.9,28.8,7.6,25.8,57.3-6.8,52.9-14-1.9-107.7-9.9-99.1-29.9C286.5,332.6,299.9,330.1,310.7,327.5Z",
    style: {
      fill: "#0b63e9",
      stroke: "#000",
      strokeLinecap: "square",
      strokeLinejoin: "bevel",
      strokeWidth: "1.414199948310852px",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.2,364.2c28.7,34.8,3.2,65.1-22.4,63.1-22.6-1.7-20.9-67.6-73.3-82.8C257,342.9,355,358.6,358.2,364.2Z",
    style: {
      fill: "#0b63e9",
      stroke: "#000",
      strokeLinecap: "square",
      strokeLinejoin: "bevel",
      strokeWidth: "1.414199948310852px",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.1,316.6c21.9,5.9,69.6-58.4,72.6-61.1,41.6-37.8,55.7,8.2,44.1,27.2-11.4,18.7-74.3,50.5-88.2,44.8C300.9,325.8,274.7,321.4,276.1,316.6Z",
    style: {
      fill: "#0b63e9",
      stroke: "#000",
      strokeLinecap: "square",
      strokeLinejoin: "bevel",
      strokeWidth: "1.414199948310852px",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.3,313.4c17.9,4.8,57-47.8,59.5-50,34.1-31,45.6,6.7,36.1,22.2-9.3,15.3-60.8,41.3-72.3,36.7C308.7,320.9,287.2,317.3,288.3,313.4Z",
    style: {
      fillRule: "evenodd",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.4,327.7c38.4-15.3,50.7-15.6,64.9-11.8,22.7,6,20.4,45.3-5.4,41.8-11.1-1.5-85.1-7.8-78.3-23.6C301.3,331.8,311.9,329.7,320.4,327.7Z",
    style: {
      fillRule: "evenodd",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.5,363.1c24.1,29.2,2.7,54.6-18.8,53-18.9-1.4-17.5-56.7-61.5-69.5C265.5,345.3,347.8,358.4,350.5,363.1Z",
    style: {
      fillRule: "evenodd",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.7,260.1c-4.2-5.7-5.4-12.3.4-13.8,2.1-.1,5.5,1.7,8,11,2.1,7.8.9,15.9-.1,18.2C381.8,294.7,389.7,271,381.7,260.1Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.2,326.5c-7.3,14.2,30.1,5.8,63.1,56.7,8.9,18.8,27.3,23.7,36.3,14.6,5.9-5.9,17-25-18-40.4-38.3-15.5-52.9-25,23.4-9.2,11.1.5,18.7,1.3,24.1-.3,6.5-2,12-8.3,10.9-15.6-1.8-11.7-15.9-15.8-29.5-12.9-22.1,4.7-109.1,38.7-11.5-7.5,18.3-8.6,23.4-21.1,19.2-31.1-4.4-10.3-23.6-7.8-37.2,7.6C279.2,342.8,253.8,302.2,246.2,326.5Z",
    style: {
      fill: "#cc200a",
      stroke: "#000",
      strokeLinecap: "square",
      strokeLinejoin: "bevel",
      strokeWidth: "1.414199948310852px",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.9,327.2c-6.3,12.2,25.8,5,54.2,48.6,7.7,16.1,23.4,20.3,31.2,12.5,5.1-5.1,14.6-21.4-15.5-34.6-32.9-13.2-45.5-21.4,20.1-7.9,9.5.5,16.1,1.1,20.7-.3,5.6-1.7,10.3-7.2,9.3-13.4-1.5-10-13.6-13.6-25.4-11.1-19,4-93.7,33.1-9.9-6.4,15.7-7.4,20.1-18.1,16.5-26.6-3.7-8.8-20.3-6.7-31.9,6.5C281.2,341.2,259.4,306.3,252.9,327.2Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.9,328.2c-5.5,10.6,22.5,4.3,47.3,42.3,6.7,14,20.4,17.7,27.2,10.9,4.4-4.4,12.7-18.6-13.5-30.2-28.6-11.5-39.6-18.7,17.5-6.8,8.3.4,14,1,18-.3,4.9-1.5,9-6.2,8.1-11.7-1.3-8.7-11.9-11.8-22.1-9.6-16.5,3.5-81.6,28.9-8.6-5.6,13.7-6.5,17.5-15.8,14.4-23.2-3.3-7.7-17.7-5.8-27.8,5.7C281.6,340.4,262.6,310.1,256.9,328.2Z",
    style: {
      fillRule: "evenodd",
      opacity: 0.1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTail);
export default __webpack_public_path__ + "static/media/tail.73ae2383b446ede6d073ad03dcc39e47.svg";
export { ForwardRef as ReactComponent };